import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelRadio as _vModelRadio, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "upload-component" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "radio-group" }
const _hoisted_5 = { class: "radio-option" }
const _hoisted_6 = { class: "radio-option" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = {
  key: 0,
  class: "form-group"
}
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = {
  key: 0,
  class: "submitted-info"
}
const _hoisted_14 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"])),
      class: "asset-form"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _cache[11] || (_cache[11] = _createElementVNode("label", { for: "assetType" }, "资产类型：", -1)),
        _withDirectives(_createElementVNode("select", {
          id: "assetType",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.assetInfo.type) = $event)),
          required: ""
        }, _cache[10] || (_cache[10] = [
          _createStaticVNode("<option value=\"\" data-v-b0f598ce>请选择</option><option value=\"农用地\" data-v-b0f598ce>农用地</option><option value=\"建设用地\" data-v-b0f598ce>建设用地</option><option value=\"未利用地\" data-v-b0f598ce>未利用地</option><option value=\"其他用地\" data-v-b0f598ce>其他用地</option><option value=\"住宅用地\" data-v-b0f598ce>住宅用地</option><option value=\"商业用房\" data-v-b0f598ce>商业用房</option><option value=\"工业用房\" data-v-b0f598ce>工业用房</option><option value=\"其他用房\" data-v-b0f598ce>其他用房</option>", 9)
        ]), 512), [
          [_vModelSelect, _ctx.assetInfo.type]
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[14] || (_cache[14] = _createElementVNode("label", null, "交易方式：", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.assetInfo.transactionType) = $event)),
              value: "出租",
              required: ""
            }, null, 512), [
              [_vModelRadio, _ctx.assetInfo.transactionType]
            ]),
            _cache[12] || (_cache[12] = _createElementVNode("span", null, "出租", -1))
          ]),
          _createElementVNode("label", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.assetInfo.transactionType) = $event)),
              value: "出售",
              required: ""
            }, null, 512), [
              [_vModelRadio, _ctx.assetInfo.transactionType]
            ]),
            _cache[13] || (_cache[13] = _createElementVNode("span", null, "出售", -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[15] || (_cache[15] = _createElementVNode("label", { for: "address" }, "地址：", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "address",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.assetInfo.address) = $event)),
          placeholder: "请输入资产地址",
          required: ""
        }, null, 512), [
          [_vModelText, _ctx.assetInfo.address]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[16] || (_cache[16] = _createElementVNode("label", { for: "propertyCertificate" }, "产权证号：", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "propertyCertificate",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.assetInfo.propertyCertificate) = $event)),
          placeholder: "请输入产权证号",
          required: ""
        }, null, 512), [
          [_vModelText, _ctx.assetInfo.propertyCertificate]
        ])
      ]),
      (_ctx.isHouseType)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _cache[17] || (_cache[17] = _createElementVNode("label", { for: "houseLayout" }, "房屋户型：", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "houseLayout",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.assetInfo.houseLayout) = $event)),
              placeholder: "请输入房屋户型（如：3室2厅1卫）"
            }, null, 512), [
              [_vModelText, _ctx.assetInfo.houseLayout]
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        _cache[18] || (_cache[18] = _createElementVNode("label", { for: "area" }, "面积（㎡）：", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "number",
          id: "area",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.assetInfo.area) = $event)),
          placeholder: "请输入面积",
          required: ""
        }, null, 512), [
          [_vModelText, _ctx.assetInfo.area]
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[19] || (_cache[19] = _createElementVNode("label", { for: "price" }, "价格（元）：", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "number",
          id: "price",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.assetInfo.price) = $event)),
          placeholder: "请输入价格",
          required: ""
        }, null, 512), [
          [_vModelText, _ctx.assetInfo.price]
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _cache[20] || (_cache[20] = _createElementVNode("label", { for: "highlights" }, "亮点：", -1)),
        _withDirectives(_createElementVNode("textarea", {
          id: "highlights",
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.assetInfo.highlights) = $event)),
          placeholder: "请输入资产亮点（如：交通便利、环境优美等）",
          rows: "4"
        }, null, 512), [
          [_vModelText, _ctx.assetInfo.highlights]
        ])
      ]),
      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "form-group full-width" }, [
        _createElementVNode("button", { type: "submit" }, "发布")
      ], -1))
    ], 32),
    (_ctx.submitted)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _cache[30] || (_cache[30] = _createElementVNode("h3", null, "已发布的资产信息", -1)),
          _createElementVNode("p", null, [
            _cache[22] || (_cache[22] = _createElementVNode("strong", null, "资产类型：", -1)),
            _createTextVNode(_toDisplayString(_ctx.assetInfo.type), 1)
          ]),
          _createElementVNode("p", null, [
            _cache[23] || (_cache[23] = _createElementVNode("strong", null, "交易方式：", -1)),
            _createTextVNode(_toDisplayString(_ctx.assetInfo.transactionType), 1)
          ]),
          _createElementVNode("p", null, [
            _cache[24] || (_cache[24] = _createElementVNode("strong", null, "地址：", -1)),
            _createTextVNode(_toDisplayString(_ctx.assetInfo.address), 1)
          ]),
          _createElementVNode("p", null, [
            _cache[25] || (_cache[25] = _createElementVNode("strong", null, "产权证号：", -1)),
            _createTextVNode(_toDisplayString(_ctx.assetInfo.propertyCertificate), 1)
          ]),
          (_ctx.isHouseType)
            ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                _cache[26] || (_cache[26] = _createElementVNode("strong", null, "房屋户型：", -1)),
                _createTextVNode(_toDisplayString(_ctx.assetInfo.houseLayout), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("p", null, [
            _cache[27] || (_cache[27] = _createElementVNode("strong", null, "面积：", -1)),
            _createTextVNode(_toDisplayString(_ctx.assetInfo.area) + " ㎡", 1)
          ]),
          _createElementVNode("p", null, [
            _cache[28] || (_cache[28] = _createElementVNode("strong", null, "价格：", -1)),
            _createTextVNode(_toDisplayString(_ctx.assetInfo.price) + " 元", 1)
          ]),
          _createElementVNode("p", null, [
            _cache[29] || (_cache[29] = _createElementVNode("strong", null, "亮点：", -1)),
            _createTextVNode(_toDisplayString(_ctx.assetInfo.highlights), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}